import React from 'react';
//import $ from 'jquery';

import './btn-do.css';


function BtnDo() {
    return(
        <>
            <button type="button" className='btn-do' id="querofazerprojetobtn" >QUERO FAZER MEU PROJETO</button>
        </>
    );
}

function BtnDoProj() {
    return(
        <>
            <button type="button" className='btn-do-proj' id="querofazerprojetobtn" >QUERO FAZER MEU PROJETO</button>
        </>
    );
}

function BtnDoStudio() {
    return(
        <>
            <button type="button" className='btn-do-studio' id="querofazerprojetobtn">QUERO FAZER MEU PROJETO</button>
        </>
    );
} 

export {BtnDo, BtnDoProj, BtnDoStudio};